import React from 'react';

import { virtualCardTypes } from './actions'



const initialState = {
    isFetching: false,
    status: 'initial',
}


export function virtualCard(state = initialState, action) {
    switch(action.type) {

        case virtualCardTypes.REQUEST_VERIFICATION:
            state = {...state}
            state.status = 'start-requesting-verification'
            return state
            
            case virtualCardTypes.RECEIVE_VERIFICATION:
            state = {...state}
            state.status = 'requesting-verification'
            state.cardVerificationRequestToken = action.data.token
            return state


        case virtualCardTypes.RECEIVE_STATUS:
            state = {...state}
            state.cardVerificationRequestStatus = action.data.status
            if (action.data.status === "done") {
                state.status = 'cardnumber-verified'
            }
            if (action.data.status === "failed") {
                state.status = 'verification-failed'
            }
            return state

        case virtualCardTypes.REMOVE:
            state = {...state, status: 'initial'}
            delete state.results
            return state

        case virtualCardTypes.RECEIVE:
            state = {...state}
            state.status = 'virtualcard-received'
            state.results = action.data
            
            return state

        case virtualCardTypes.RECEIVE_SAVE:
            state = {...state}
            state.status = 'virtualcard-saved'

            return state

        case virtualCardTypes.ERROR_SAVE:
        case virtualCardTypes.ERROR:
            state = {...state}
            state.status = 'virtualcard-save-error'

            return state

        default:
            return state
    }
}